import { createAction, props } from '@ngrx/store';
import { ChartConsultation } from '@app/core/models/chart';

export const getChartConsultations = createAction('[Pet] Get chart consultations', props<{ patientId: string }>());

export const getChartConsultationsSuccess = createAction(
  '[Pet] Get chart consultations Success',
  props<{ chartConsultationWeights: ChartConsultation[] }>()
);
